import type { App } from 'vue'
import PageHeaderWithName from './PageHeaderWithName.vue'

export default {
  install(app: App) {
    app.component('PageHeaderWithName', PageHeaderWithName)
  },
}
